module.exports = require("path");


//////////////////
// WEBPACK FOOTER
// external "path"
// module id = 4
// module chunks = 0